<template>
    <vue-good-table
        mode="remote"
        :total-rows="totalRows"
        :is-loading="isLoading"
        :pagination-options="{
            enabled: true,
            perPage: serverParams.perPage,
            perPageDropdown: [10, 50, 100],
            dropdownAllowAll: false,
            setCurrentPage: serverParams.page,
        }"
        :rows="rows"
        :columns="columns"
        @page-change="onPageChange"
        @sort-change="onSortChange"
        @column-filter="onColumnFilter"
        @per-page-change="onPerPageChange"
        @form-submit-success="loadRows"
    >
        <template #table-row="props">
            <span v-if="(props.column.label === 'Action')">
                <router-link
                    v-if="props.row.can_edit"
                    :to="props.row.url_edit"
                    class="btn btn-primary btn-sm me-2 mb-2"
                >
                    Edit Series
                </router-link>

                <router-link
                    :to="props.row.url_show"
                    class="btn btn-primary btn-sm me-2 mb-2"
                >
                    View Lessons
                </router-link>
            </span>
            <span v-else>
                {{ props.formattedRow[props.column.field] }}
            </span>
        </template>
    </vue-good-table>
</template>

<script>
import Table from "../mixins/Table.js";

export default {
  mixins: [
    Table,
  ],

  data() {
    return {
      columns: [
        {
          label: "ID",
          field: "id",
          filterOptions: {
            enabled: true,
            filterFn: () => true,
          },
        },
        {
          label: "Title",
          field: "title",
          filterOptions: {
            enabled: true,
            filterFn: () => true,
          },
        },
        {
          label: "Slug",
          field: "slug",
          filterOptions: {
            enabled: true,
            filterFn: () => true,
          },
        },
        {
          label: "Sequence",
          field: "sequence_number",
          sortable: false,
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Lessons",
          field: "lesson_count",
          sortable: false,
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Status",
          field: "is_archived",
          filterOptions: {
            enabled: true,
            placeholder: "Filter Status",
            filterDropdownItems: [
              { value: 1, text: "Archived" },
              { value: 0, text: "Active" },
            ],
            filterFn: () => true,
          },
          formatFn: (value) => (value ? "Archived" : "Active"),
          tdClass: (row) => (row.is_archived ? "row-archived" : "row-active"),
        },
        {
          label: "Action",
          field: "btn",
          sortable: false,
          filterOptions: {
            enabled: false,
          },
        },
      ],
      rows: [],
      totalRows: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "id",
          type: "asc",
        },
        page: 1,
        perPage: 10,
      },
    };
  },
};
</script>
